// Scoped-CSS demo for "71 colliding selectors". Every rule is prefixed with
// the widget's own element id so the demo styles can never leak onto the host
// page — a hard requirement, since this markup lives in database content.
//
// Isolated mode: each page's `.section_0` is scoped to its own page, so the
// same positional class name can mean two different things without colliding.
// Pooled mode: the per-page scoping is dropped, both pages' rules land on one
// `#scope .section_0` selector, and whichever comes last (page B) wins for
// every card — silently restyling page A.

const A_RULES = "background:#dbeafe;color:#1e3a8a;border-left:4px solid #3b82f6;"
const B_RULES = "background:#dcfce7;color:#166534;border-left:4px solid #16a34a;"
const BASE = "padding:10px 12px;border-radius:6px;transition:background .3s,color .3s,border-color .3s;"

export function isolatedCss(scopeId) {
  const s = `#${scopeId}`
  return [
    `${s} .section_0 { ${BASE} }`,
    `${s} [data-page="a"] .section_0 { ${A_RULES} }`,
    `${s} [data-page="b"] .section_0 { ${B_RULES} }`
  ].join("\n")
}

export function pooledCss(scopeId) {
  const s = `#${scopeId}`
  return [
    `${s} .section_0 { ${BASE} }`,
    `${s} .section_0 { ${A_RULES} }`,
    `${s} .section_0 { ${B_RULES} }`
  ].join("\n")
}

// True only when every selector in the stylesheet is prefixed with `#scopeId`
// — i.e. nothing can leak globally. Used by the controller's tests as the
// guard on the widget's non-leak contract.
export function everySelectorScoped(css, scopeId) {
  return selectors(css).every(sel => sel.includes(`#${scopeId}`))
}

function selectors(css) {
  return css
    .split("}")
    .map(block => block.split("{")[0].trim())
    .filter(Boolean)
}
